import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';

export default {
    async created() {
        try {
            this.allowExternalInvitees = await this.$services.settings.getSetting(this.event._id, 'meetings.allow-external-invitees');
        } catch (error) {
            console.error(`[${this.$options.name}] Could not load settings`, error);
        }
    },

    data() {
        return {
            allowExternalInvitees: false,
        };
    },

    methods: {

        getActionController(action) {
            return this.$services.blueprint.getControllerByName(action.moduleName || 'meetings', action.controllerKey);
        },

        isActionVisible(action) {
            const controller = this.getActionController(action);
            if (!controller) {
                return false;
            }

            return controller.permission ? this.$services.user.hasPermission(controller.permission) : true;
        },

        isActionAllowed(action) {
            if (action.controllerKey === 'create' && action.moduleName === 'prospects' && !this.allowExternalInvitees) {
                return false;
            }
            return this.isActionVisible(action);
        },

        async performAction(action) {
            const controller = this.getActionController(action);
            const fpType = controller.routeOptions.modelFpType;
            const metadata = await this.$services.metadata.getMetadataForType(this.event._id, fpType);
            const type = this.$utils.strings.humanizeType(metadata, fpType);

            this.$modal.show(ModalForm, {
                title: this.$t('generic_form.external_picker.new_external', [type.toLocaleLowerCase()]),
                event: this.event,
                model: {},
                fpType,
                onSave: async res => {
                    await this.addProspectToPicker(res._id);
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        onEditProspect(prospectId) {
            this.$modal.show(ModalForm, {
                title: this.$t('generic_form.external_picker.external_participant'),
                event: this.event,
                docId: prospectId,
                fpType: 'prospect',
                onSave: async res => {
                    this.updateProspectInPicker(res._id);
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        async addProspectToPicker(prospectId) {
            try {
                const prospects = await this.$services.appScripts.callAppScript(this.event._id, this.attendees_script, { ids: [prospectId] });
                const newProspect = { ...prospects[0], attendance: 'pending' };
                this.innerValue = [newProspect, ...this.innerValue];
                this.loadStatus();
            } catch (error) {
                console.error('[AttendeePicker] Error while saving prospect:', error);
            }
        },

        async updateProspectInPicker(prospectId) {
            try {
                const [updatedProspect] = await this.$services.appScripts.callAppScript(this.event._id, this.attendees_script, { ids: [prospectId] });
                const index = this.innerValue.findIndex(pax => pax._id === updatedProspect._id);

                if (index !== -1) {
                    const updatedInnerValue = [...this.innerValue];
                    const currentPax = updatedInnerValue[index];
                    for (const key in updatedProspect) {
                        if (currentPax[key] !== updatedProspect[key]) {
                            this.$set(currentPax, key, updatedProspect[key]);
                        }
                    }
                    this.innerValue = updatedInnerValue;
                }
            } catch (error) {
                console.error('[AttendeePicker] Error while saving prospect:', error);
            }
        }
    }
};
